import React from "react";
import { Action } from "../interfaces/actions";
import { IUser } from "../interfaces";

export const UserContext = React.createContext<IUser | null>(null);

export const AppDispatch = React.createContext<React.Dispatch<Action> | null>(null);
